<template>
    <div>
        <h1 style="font-size: 24px; color: black;">游戏匹配报表</h1>
        <div class="block" >
            <span >游戏名称：</span>
            <el-select v-model="queryData.originId"  filterable placeholder="请选择/输入">
                <el-option
                        v-for="item in gameList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
            <span class="demonstration">日期：</span>
            <el-date-picker
                    v-model="queryData.timeDate"
                    type="daterange"
:clearable="false"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
            </el-date-picker>&emsp;&emsp;
            <span >渠道：</span>
            <el-select v-model="queryData.channelId" @change="selectGoodsByChannelId($event)"  clearable placeholder="请选择">
                <el-option value="0" label="全部"></el-option>
                <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="queryData.subChannelId"  clearable placeholder="请选择" >
                <el-option value="0" label="全部"></el-option>
                <el-option v-for="item in subChannelList" :label="item.name" :key="item.id" :value="item.subChannel"></el-option>
            </el-select>
            <el-button  type="primary" class="margin-left-10" @click="query">查询</el-button>
            <el-button  type="primary" @click="exportExcel()">导出报表</el-button>
        </div>
            <h1>
<!--                <el-table border :data="matrixReport.slice((queryInfo.pagenum-1)*queryInfo.pagesize,queryInfo.pagenum*queryInfo.pagesize)"-->
                <el-table border :data="matrixReport"
                          :header-cell-style="{background:'#282828'}"
                          ref="filterTable"
                          @sort-change='sortChange'
                          max-height="820">
                    <el-table-column prop="dt"  label="日期" sortable='custom'></el-table-column>
                    <el-table-column prop="name"  label="导出游戏名称"></el-table-column>
                    <el-table-column prop="user"  label="导出游戏用户" sortable='custom'></el-table-column>
                    <el-table-column   label="导出占比" sortable='custom' prop="exportRate">
                        <template slot-scope="scope" >
                            {{scope.row.exportRate===null?'0.00%':(scope.row.exportRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="new_user"  label="新增" sortable='custom'></el-table-column>
                    <el-table-column prop="open"  label="游戏频次" sortable='custom'></el-table-column>
                    <el-table-column  label="次留率" sortable='custom' prop="r1Rate">
                        <template slot-scope="scope" >
                            {{scope.row.r1Rate===null?'0.00%':(scope.row.r1Rate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column   label="人均游戏时长" sortable='custom' prop="perTime">
                        <template slot-scope="scope" >
                            {{(scope.row.perTime/60).toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column   label="人均游戏频次" sortable='custom' prop="perRate">
                        <template slot-scope="scope" >
                            {{scope.row.perRate.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column   label="人均视频个数" sortable='custom' prop="perNum">
                        <template slot-scope="scope" >
                            {{scope.row.perNum.toFixed(2)}}
                        </template>
                    </el-table-column>
                </el-table>
            </h1>
        <el-row>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pagenum"
                    :page-sizes="[20,30,50]"
                    :page-size="queryInfo.pagesize"
                    layout="total, sizes, prev, pager, next"
                    :total="queryInfo.total">
            </el-pagination>
        </el-row>


    </div>
</template>

<script>
import {
    gameSimpleList,
  channelList,
  // matrixGameReportList,
  searchMatrixGameReportList, downloadData,
} from "@/http/api";
import utils from '@/utils'
    // import XLSX from "xlsx";
    // import FileSaver from "file-saver";

    export default {
        name: "MatrixReport",
        data(){
            return{
                queryData:{
                    originId:-1,
                    channelId:'',
                    subChannelId:'',
                    timeDate:['',''],
                },
                queryInfo:{
                    pagesize:20,
                    pagenum:1,
                    total:0,
                },
                queryTrueData:{
                    originId:-1,
                    channelId:'',
                    subChannelId:'',
                    startTime:'',
                    endTime:'',
                  order:null,
                  prop:null
                },
                gameList:[],
                matrixReport:[],
                channelList:[],
                subChannelList:[],
                watchTag:'',
                plateRule:[
                    {id:12,val:'退出游戏'},
                    {id:15,val: '侧边栏'},
                ]
            }
        },
        methods:{
            selectGoodsByChannelId(val){
                this.watchTag = val;
                if(val !== null && val !== '' && val !== undefined && val !=='0') {
                    this.subChannelList = this.channelList.filter(channel => channel.id === val )[0].children.filter(subChannel=>subChannel.state===1);
                }
                if (val==='0'){
                    this.subChannelList=[];
                }
            },
            handleSizeChange(newSize){
                this.queryInfo.pagesize=newSize;
                this.queryMatrixReport();

            },
            query(){
                this.queryInfo.pagenum=1;
                this.queryMatrixReport();

            },
            handleCurrentChange(newPage){
                this.queryInfo.pagenum=newPage;
              this.queryMatrixReport();
            },
            // exportExcel () {
            //     this.queryInfo.pagesize = this.queryInfo.total;
            //     this.queryInfo.pagenum = 1;
            //     this.$nextTick(function () {
            //         let wb = XLSX.utils.table_to_book(this.$refs.filterTable.$el);
            //         let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
            //         try {
            //             FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), '矩阵日报'+new Date().toLocaleString()+'.xlsx');
            //         } catch (e) {
            //             if (typeof console !== 'undefined') console.log(e, wbout)
            //         }
            //         this.queryInfo.pagesize = 10;
            //         return wbout;
            //     })
            // },
          exportExcel () {
            let fileName = new Date().toLocaleString()+'游戏匹配报表.xlsx';
            downloadData(
                '/matrix/searchMatrixGameReportExcel',
                Object.assign(this.queryTrueData),
                fileName
            )
          },
          sortChange(order){
            this.queryTrueData.order=order.order;
            this.queryTrueData.prop=order.prop;
            this.queryMatrixReport();
          },
            queryMatrixReport(){
                if (this.queryData.timeDate===null){
                    this.queryData.timeDate=['',''];
                }
                this.queryTrueData.startTime= this.queryData.timeDate[0];
                this.queryTrueData.endTime=this.queryData.timeDate[1];
                this.queryTrueData.originId=this.queryData.originId;
                this.queryTrueData.channelId=this.queryData.channelId;
                this.queryTrueData.subChannelId=this.queryData.subChannelId;
              this.queryTrueData.size=this.queryInfo.pagesize;
              this.queryTrueData.page=this.queryInfo.pagenum;
                searchMatrixGameReportList(this.queryTrueData).then(resp=>{
                    // this.matrixReport=resp.data.info.sort((a,b) => (new Date(b.dt) - new Date(a.dt)));
                  this.matrixReport=resp.data.info.list;
                    // let _this =this;
                    // this.matrixReport.forEach(function (matrixReport) {
                    //     _this.gameList.forEach(function (game) {
                    //         if (game.id === matrixReport.game_id){
                    //             _this.$forceUpdate();
                    //             _this.$set(matrixReport,'name',game.name);
                    //         }
                    //     })
                    // });
                  this.queryInfo.total=resp.data.info.totalElements;
                });
            }
        },

        watch:{
            watchTag(){
                this.queryData.subChannelId='';
            }
        },
        created() {
            this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
            channelList().then(resp=>{
                this.channelList=resp.data.info;
            });
            gameSimpleList().then(resp=>{
                this.gameList=resp.data.info;
                this.gameList.unshift({id:-1,name:'游戏中心'});

            });
            // matrixGameReportList().then(resp=>{
            //     this.matrixReport=resp.data.info.filter(pr=>pr.origin_id===-1);
            //     this.queryInfo.total=this.matrixReport.length;
            // });
            this.queryMatrixReport();
        }
    }
</script>

<style scoped>

</style>
